import React from "react";
import "../Components/Styles/Header.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import Dropdown from "./Dropdown";
import DropdownItem from "./DropdownItem";

const Header: React.FC = () => {
  return (
    <header className="AppHeader">
      <motion.div
        onTap={() => {
          window.location.href = "/";
        }}
      >
        <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="AppHeaderLogo" />
      </motion.div>
      {/* <Dropdown>
        <DropdownItem label="xxxx" labelRight="xxxxxx" />
        <DropdownItem label="xxxx" labelRight="xxxxxx" />
      </Dropdown>
      <motion.div
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="AppHeaderIconWrapper"
      >
        <FontAwesomeIcon icon={faBars} className="AppHeaderIcon" size="lg" />
      </motion.div> */}
    </header>
  );
};

export default Header;
